import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { FrecuenciaDistribuidorSearchContent } from './components/FrecuenciaDistribuidorSearchContent';

export default function FrecuenciaDistribuidorSearch() {

    return (
        <MainContent component={<FrecuenciaDistribuidorSearchContent/>} titulo='Frecuencias de Distribución' />
    );

};